import { GlobeIcon } from "@fluentui/react-icons-mdl2";
import { Image } from "@fluentui/react/lib/Image";

import { DataSourceIcons } from "Images";
import { isNullOrWhiteSpace } from "Utils/String";
import { ICON_SIZE, useDataSourceIconStyles } from "./UseDataSourceIconStyles";
import { IDataSourceIconProps } from "./IDataSourceIconProps";

export function DataSourceIcon(props: IDataSourceIconProps): JSX.Element {
  const { dataSource, styleSet } = props;
  const styles = useDataSourceIconStyles(styleSet);
  const src = DataSourceIcons(dataSource);

  return isNullOrWhiteSpace(src)
    ? (
      <GlobeIcon className={styles.icon} title={dataSource} />
    )
    : (
      <Image className={styles.icon} width={ICON_SIZE} height={ICON_SIZE} alt={dataSource} src={src} />
    );
}
